const isDevelopment = process.env.NODE_ENV === "development";

const API_HOST_DEV = "http://127.0.0.1:8888/api";
const API_HOST_PROD = "https://pokestats.top/livestream/api";

const API_HOST = isDevelopment ? API_HOST_DEV : API_HOST_PROD;

function buildApiUrl(path: string): string {
  return `${API_HOST}/${path.replace(/^\/+/, "")}`;
}

export const TEAMSEARCH_API_URL = buildApiUrl("teamsearch/img");
export const OPPONENT_IMAGE_API_URL = buildApiUrl("opponent/img");

export const TEAMSEARCH_REGS = [
  "Champions Reg.M-C",
  "Champions Reg.M-B",
  "Champions Reg.M-A",
];
